<template>
    <div id="search-form" class="search-form-be" :class="searchOpen ? 'visible' : 'hidden'" data-e2e="bookingEngine">
        <b-form data-e2e="searchForm">  
            <div class="search-form-item" id="search-form-autocomplete" data-e2e="searchFormAutocomplete">
                <autocomplete
                    :appId="config.here.app_id"
                    :appCode="config.here.app_code"
                    :apiKey="config.hereApiKey"
                    :searchByGeoEndpoint="config.endpoints.searchByGeo"
                    :searchInSalabamEndpoint="config.endpoints.searchInSalabam"
                    :searchByPropertyEndpoint="config.endpoints.searchByProperty"
                    :suggestionsEndpoint="config.endpoints.here.autocomplete"
                    :geocodeEndpoint="config.endpoints.here.lookup"
                    :language="'it'"
                    :minMatchingChars="3"
                    :minDigits="3"
                    :maxMatches="10"
                    :debounceMs="500"
                    @autocompleteFocus="setSearchFocus('visible')"
                    @autocompleteBlur="setSearchFocus('hidden')"
                    @geo="setGeo"
                />
                <div id="toggle-search-settings" class="icon" @click="setSearchFocus('toggle')">
                    <SvgLens />
                </div>
            </div>
            <div id="search-form-datepicker" class="search-form-item searchFormHidden" data-e2e="searchFormDatepicker">
                <datepicker
                :startCheckinDate="checkinRange.min"
                :endCheckinDate="checkinRange.max"
                :datePickerSelector="datePickerSelector"
                @dates="setDates"
                />
            </div>
            <div id="search-form-nights" class="search-form-item searchFormHidden" data-e2e="searchFormNights">


                <div id="input-nights-desktop">
                    <div class="input-icon">
                        <svg width="31" height="35" viewBox="0 0 31 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M27.977 3.95093H23.6769C23.6291 3.9537 23.5813 3.94652 23.5366 3.92944C23.4918 3.91237 23.4511 3.88597 23.4173 3.85205C23.3835 3.81813 23.3572 3.77747 23.3403 3.73267C23.3233 3.68786 23.3161 3.63986 23.319 3.59204V1.94312C23.3105 1.66355 23.1934 1.3981 22.9926 1.20337C22.7918 1.00863 22.5232 0.899902 22.2435 0.899902C21.9638 0.899902 21.6951 1.00863 21.4943 1.20337C21.2936 1.3981 21.1766 1.66355 21.168 1.94312V3.59204C21.1709 3.63995 21.1637 3.68803 21.1467 3.73291C21.1297 3.77779 21.1032 3.81836 21.0693 3.85229C21.0353 3.88623 20.9946 3.91268 20.9498 3.92969C20.9049 3.9467 20.8569 3.95385 20.809 3.95093H9.909C9.86117 3.9537 9.81325 3.94652 9.76849 3.92944C9.72373 3.91237 9.68318 3.88597 9.64935 3.85205C9.61553 3.81813 9.58928 3.77747 9.57233 3.73267C9.55538 3.68786 9.54806 3.63986 9.55096 3.59204V1.94312C9.54244 1.66355 9.42544 1.3981 9.22467 1.20337C9.02391 1.00863 8.75522 0.899902 8.47552 0.899902C8.19583 0.899902 7.92714 1.00863 7.72638 1.20337C7.52561 1.3981 7.40849 1.66355 7.39996 1.94312V3.59204C7.40288 3.63995 7.39561 3.68803 7.3786 3.73291C7.36159 3.77779 7.33527 3.81836 7.30133 3.85229C7.26739 3.88623 7.22658 3.91268 7.1817 3.92969C7.13682 3.9467 7.08886 3.95385 7.04095 3.95093H2.74103C2.0781 3.95897 1.44457 4.22603 0.975769 4.69482C0.506972 5.16362 0.240037 5.79703 0.231995 6.45996V31.6951C0.239778 32.3582 0.506579 32.9919 0.975403 33.4609C1.44423 33.9299 2.07793 34.197 2.74103 34.2051H27.977C28.6401 34.197 29.2738 33.9299 29.7426 33.4609C30.2114 32.9919 30.4782 32.3582 30.486 31.6951V6.45996C30.4881 6.12988 30.4247 5.80268 30.2994 5.49731C30.174 5.19195 29.9893 4.91456 29.7559 4.68115C29.5225 4.44775 29.245 4.26303 28.9396 4.1377C28.6343 4.01236 28.3071 3.9488 27.977 3.95093ZM28.335 31.6951C28.3379 31.7429 28.3306 31.7906 28.3137 31.8354C28.2967 31.8803 28.2705 31.9212 28.2366 31.9551C28.2028 31.989 28.1623 32.0152 28.1175 32.0322C28.0727 32.0493 28.0248 32.0567 27.977 32.054H2.74103C2.69312 32.0569 2.64516 32.0497 2.60028 32.0327C2.5554 32.0157 2.51459 31.9893 2.48065 31.9553C2.44671 31.9214 2.42039 31.8806 2.40338 31.8357C2.38637 31.7908 2.3791 31.743 2.38202 31.6951V15.2061C2.37925 15.1582 2.38667 15.1104 2.40375 15.0657C2.42082 15.0209 2.4471 14.9801 2.48102 14.9463C2.51494 14.9125 2.55572 14.8863 2.60052 14.8694C2.64533 14.8524 2.69321 14.8452 2.74103 14.8481H27.977C28.0248 14.8452 28.0726 14.8524 28.1174 14.8694C28.1621 14.8863 28.2028 14.9124 28.2366 14.9463C28.2705 14.9801 28.2967 15.0209 28.3137 15.0657C28.3306 15.1104 28.3379 15.1583 28.335 15.2061V31.6951ZM28.335 12.3391C28.3379 12.3869 28.3306 12.4347 28.3137 12.4795C28.2967 12.5243 28.2705 12.5648 28.2366 12.5986C28.2028 12.6325 28.1621 12.6588 28.1174 12.6758C28.0726 12.6927 28.0248 12.6999 27.977 12.697H2.74103C2.69321 12.6999 2.64533 12.6927 2.60052 12.6758C2.55572 12.6588 2.51494 12.6325 2.48102 12.5986C2.4471 12.5648 2.42082 12.5243 2.40375 12.4795C2.38667 12.4347 2.37925 12.3869 2.38202 12.3391V6.45996C2.37926 6.41209 2.38668 6.36439 2.40375 6.31958C2.42081 6.27477 2.44712 6.23385 2.48102 6.19995C2.51492 6.16605 2.5556 6.13987 2.6004 6.1228C2.64521 6.10574 2.69316 6.09832 2.74103 6.10107H7.04095C7.08882 6.09832 7.13677 6.10574 7.18158 6.1228C7.22639 6.13987 7.26706 6.16605 7.30096 6.19995C7.33487 6.23385 7.36117 6.27477 7.37823 6.31958C7.3953 6.36439 7.40272 6.41209 7.39996 6.45996V8.10913C7.40849 8.38869 7.52561 8.6539 7.72638 8.84863C7.92714 9.04337 8.19583 9.15234 8.47552 9.15234C8.75522 9.15234 9.02391 9.04337 9.22467 8.84863C9.42544 8.6539 9.54244 8.38869 9.55096 8.10913V6.45996C9.54806 6.41214 9.55538 6.36439 9.57233 6.31958C9.58928 6.27477 9.61553 6.23412 9.64935 6.2002C9.68318 6.16627 9.72373 6.13988 9.76849 6.1228C9.81325 6.10573 9.86117 6.0983 9.909 6.10107H20.809C20.8569 6.09832 20.9047 6.10574 20.9495 6.1228C20.9943 6.13987 21.0351 6.16605 21.069 6.19995C21.1029 6.23385 21.1292 6.27477 21.1463 6.31958C21.1634 6.36439 21.1708 6.41209 21.168 6.45996V8.10913C21.1766 8.38869 21.2936 8.6539 21.4943 8.84863C21.6951 9.04337 21.9638 9.15234 22.2435 9.15234C22.5232 9.15234 22.7918 9.04337 22.9926 8.84863C23.1934 8.6539 23.3105 8.38869 23.319 8.10913V6.45996C23.3161 6.41214 23.3233 6.36439 23.3403 6.31958C23.3572 6.27477 23.3835 6.23412 23.4173 6.2002C23.4511 6.16627 23.4918 6.13988 23.5366 6.1228C23.5813 6.10573 23.6291 6.0983 23.6769 6.10107H27.977C28.0248 6.0983 28.0727 6.10573 28.1175 6.1228C28.1623 6.13988 28.2028 6.16627 28.2366 6.2002C28.2705 6.23412 28.2967 6.27477 28.3137 6.31958C28.3306 6.36439 28.3379 6.41214 28.335 6.45996V12.3391Z" fill="#333333"/>
                            <path d="M7.90704 17.787H5.54095C5.25571 17.787 4.98215 17.9003 4.78046 18.102C4.57876 18.3037 4.46552 18.5772 4.46552 18.8625C4.46552 19.1477 4.57876 19.4213 4.78046 19.623C4.98215 19.8247 5.25571 19.9379 5.54095 19.9379H7.90704C8.19015 19.9316 8.45986 19.8164 8.6601 19.6161C8.86033 19.4159 8.97563 19.1461 8.98199 18.863C8.98471 18.721 8.95875 18.5799 8.9057 18.4482C8.85265 18.3165 8.77363 18.1968 8.67328 18.0964C8.57292 17.9959 8.45325 17.9169 8.32159 17.8637C8.18994 17.8105 8.04901 17.7845 7.90704 17.787Z" fill="#333333"/>
                            <path d="M16.507 17.787H14.1411C13.8558 17.787 13.5822 17.9003 13.3806 18.102C13.1789 18.3037 13.0655 18.5772 13.0655 18.8625C13.0655 19.1477 13.1789 19.4213 13.3806 19.623C13.5822 19.8247 13.8558 19.9379 14.1411 19.9379H16.507C16.7901 19.9316 17.0598 19.8164 17.2601 19.6161C17.4603 19.4159 17.5756 19.1461 17.582 18.863C17.5847 18.721 17.5587 18.5799 17.5057 18.4482C17.4526 18.3165 17.3736 18.1968 17.2733 18.0964C17.1729 17.9959 17.0533 17.9169 16.9217 17.8637C16.79 17.8105 16.649 17.7845 16.507 17.787Z" fill="#333333"/>
                            <path d="M25.107 17.787H22.741C22.4558 17.787 22.1822 17.9003 21.9805 18.102C21.7788 18.3037 21.6655 18.5772 21.6655 18.8625C21.6655 19.1477 21.7788 19.4213 21.9805 19.623C22.1822 19.8247 22.4558 19.9379 22.741 19.9379H25.107C25.3901 19.9316 25.6598 19.8164 25.86 19.6161C26.0603 19.4159 26.1756 19.1461 26.1819 18.863C26.1847 18.721 26.1587 18.5799 26.1057 18.4482C26.0526 18.3165 25.9736 18.1968 25.8732 18.0964C25.7729 17.9959 25.6533 17.9169 25.5217 17.8637C25.39 17.8105 25.249 17.7845 25.107 17.787Z" fill="#333333"/>
                            <path d="M7.90704 22.5151H5.54095C5.25571 22.5151 4.98215 22.6283 4.78046 22.83C4.57876 23.0317 4.46552 23.3053 4.46552 23.5905C4.46552 23.8757 4.57876 24.1493 4.78046 24.351C4.98215 24.5527 5.25571 24.6659 5.54095 24.6659H7.90704C8.19032 24.6596 8.4602 24.5441 8.66046 24.3437C8.86073 24.1432 8.97588 23.8733 8.98199 23.59C8.98457 23.4481 8.95857 23.3071 8.90546 23.1755C8.85234 23.0439 8.77325 22.9245 8.67291 22.8241C8.57257 22.7238 8.45294 22.6446 8.32135 22.5915C8.18976 22.5384 8.04892 22.5125 7.90704 22.5151Z" fill="#333333"/>
                            <path d="M16.507 22.5151H14.1411C13.8558 22.5151 13.5822 22.6283 13.3806 22.83C13.1789 23.0317 13.0655 23.3053 13.0655 23.5905C13.0655 23.8757 13.1789 24.1493 13.3806 24.351C13.5822 24.5527 13.8558 24.6659 14.1411 24.6659H16.507C16.7903 24.6596 17.0602 24.5441 17.2604 24.3437C17.4607 24.1432 17.5759 23.8733 17.582 23.59C17.5845 23.4481 17.5585 23.3071 17.5054 23.1755C17.4523 23.0439 17.3732 22.9245 17.2729 22.8241C17.1725 22.7238 17.053 22.6446 16.9214 22.5915C16.7899 22.5384 16.6489 22.5125 16.507 22.5151Z" fill="#333333"/>
                            <path d="M25.107 22.5151H22.741C22.4558 22.5151 22.1822 22.6283 21.9805 22.83C21.7788 23.0317 21.6655 23.3053 21.6655 23.5905C21.6655 23.8757 21.7788 24.1493 21.9805 24.351C22.1822 24.5527 22.4558 24.6659 22.741 24.6659H25.107C25.3903 24.6596 25.6601 24.5441 25.8604 24.3437C26.0607 24.1432 26.1758 23.8733 26.1819 23.59C26.1845 23.4481 26.1585 23.3071 26.1054 23.1755C26.0523 23.0439 25.9732 22.9245 25.8729 22.8241C25.7725 22.7238 25.653 22.6446 25.5214 22.5915C25.3898 22.5384 25.2489 22.5125 25.107 22.5151Z" fill="#333333"/>
                            <path d="M7.90704 27.322H5.54095C5.39696 27.3176 5.25365 27.3422 5.11932 27.3943C4.985 27.4464 4.8625 27.525 4.75909 27.6253C4.65569 27.7256 4.57342 27.8456 4.51727 27.9783C4.46113 28.111 4.43219 28.2534 4.43219 28.3975C4.43219 28.5415 4.46113 28.6842 4.51727 28.8169C4.57342 28.9496 4.65569 29.0696 4.75909 29.1699C4.8625 29.2702 4.985 29.3488 5.11932 29.4009C5.25365 29.453 5.39696 29.4775 5.54095 29.4732H7.90704C8.19015 29.4668 8.45986 29.3514 8.6601 29.1511C8.86033 28.9509 8.97563 28.6811 8.98199 28.398C8.98471 28.256 8.95875 28.1151 8.9057 27.9834C8.85265 27.8517 8.77363 27.7321 8.67328 27.6316C8.57292 27.5312 8.45325 27.4519 8.32159 27.3987C8.18994 27.3455 8.04901 27.3195 7.90704 27.322Z" fill="#333333"/>
                            <path d="M16.507 27.322H14.1411C13.8615 27.3305 13.5962 27.4476 13.4014 27.6484C13.2067 27.8491 13.0978 28.1177 13.0978 28.3974C13.0978 28.6771 13.2067 28.9459 13.4014 29.1467C13.5962 29.3474 13.8615 29.4645 14.1411 29.4731H16.507C16.7901 29.4667 17.0598 29.3513 17.2601 29.1511C17.4603 28.9508 17.5756 28.681 17.582 28.3979C17.5847 28.2559 17.5587 28.115 17.5057 27.9833C17.4526 27.8516 17.3736 27.732 17.2733 27.6315C17.1729 27.5311 17.0533 27.4518 16.9217 27.3986C16.79 27.3454 16.649 27.3194 16.507 27.322Z" fill="#333333"/>
                            <path d="M25.107 27.322H22.741C22.4615 27.3305 22.1961 27.4476 22.0014 27.6484C21.8067 27.8491 21.6978 28.1177 21.6978 28.3974C21.6978 28.6771 21.8067 28.9459 22.0014 29.1467C22.1961 29.3474 22.4615 29.4645 22.741 29.4731H25.107C25.3901 29.4667 25.6598 29.3513 25.86 29.1511C26.0603 28.9508 26.1756 28.681 26.1819 28.3979C26.1847 28.2559 26.1587 28.115 26.1057 27.9833C26.0526 27.8516 25.9736 27.732 25.8732 27.6315C25.7729 27.5311 25.6533 27.4518 25.5217 27.3986C25.39 27.3454 25.249 27.3194 25.107 27.322Z" fill="#333333"/>
                        </svg>                        
                    </div>
                    <div class="input-with-icon">
                        <b-form-select
                            v-model="nights"
                            :options="(unlockUpselling && upsellingNightsOptions.length != 0)? upsellingNightsOptions : nightsOptions"
                            @change="value => {setNights(value)}"
                            data-e2e="searchFormNightsValue"    
                        >
                        </b-form-select>
                    </div>
                </div>


                <div id="input-nights-mobile">
                    <MobileNights
                        :nights="nights"
                        :options="(unlockUpselling && upsellingNightsOptions.length != 0)? upsellingNightsOptions : nightsOptions"
                        @change="value => {setNights(value)}"
                    />
                </div>


            </div>
            <div id="search-form-occupancy" class="search-form-item searchFormHidden" data-e2e="searchFormOccupancy">
                <div id="input-occupancy">
                    <div class="input-icon">
                        <SvgBed />
                    </div>
                    <div class="input-with-icon">
                        <occupancy @occupancy="setOccupancy" v-model="occupancy" :searchMaxAdults="config.guiSettings.searchMaxAdults" :searchMaxChildren="config.guiSettings.searchMaxChildren" />
                    </div>
                </div>
            </div>
            <div class="bookingEngineSecondRow mobile search-form-item searchFormHidden">
                <div class="bookingFocusSwitch" v-if="this.mixinGetIntegrationInfo().mode == 'booking'">
                    <div><CustomSwitch :size="'sm'" :status="unlockDestinations" :switchUniqueKey="'custom-switch-unlock-destination-sidebar'" v-on:switch-change="toggleUnlockDestinations"/></div>
                    <div class="info">
                        <SvgInfoCircle class="svgInfo" v-b-popover.hover.bottom="'Accendendo questo interruttore puoi attivare la ricerca anche fuori dall\'area geografica specifica definita dal tuo voucher Salabam'" />
                        <span>Ricerca libera in<br>Italia e nel mondo</span>
                    </div>
                </div>
            </div>
            <div id="search-form-buttons" class="search-form-item searchFormHidden" data-e2e="searchFormButtons">
                <b-button
                    v-if="!loading"
                    class="btn-search"
                    :disabled="disableSearchButton()"
                    variant="secondary"
                    v-on:click="submitSearch()"
                    data-e2e="searchFormSubmit"
                >
                    Cerca
                </b-button>
                <Spinner v-else size="sm" class="mb-0" />
            </div>            
            <div id="search-form-filters" class="search-form-item searchFormHidden">
                <filters
                    :loading="loading"
                    :amenities="amenities"
                    :categories="salabamCategories"
                    v-on:filter-changed="changeFilter()"
                />
            </div>  
        </b-form>
        <div class="bookingEngineSecondRow desktop">
            <div class="bookingFocusSwitch" v-if="this.mixinGetIntegrationInfo().mode == 'booking'">
                <div><CustomSwitch :size="'sm'" :status="unlockDestinations" :switchUniqueKey="'custom-switch-unlock-destination-sidebar'" v-on:switch-change="toggleUnlockDestinations"/></div>
                <div class="info">
                    <SvgInfoCircle class="svgInfo" v-b-popover.hover.bottom="'Accendendo questo interruttore puoi attivare la ricerca anche fuori dall\'area geografica specifica definita dal tuo voucher Salabam'" />
                    <span>Ricerca libera in Italia e nel mondo</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
//import format from 'date-fns/format'
//import it from 'date-fns/locale/it'
import Spinner from '@/components/atoms/spinner'
import Filters from '../filters'
import Autocomplete from './autocomplete'
import Datepicker from './datepicker'
import Occupancy from '../occupancy'
import CustomSwitch from '../../atoms/custom-switch'
import SvgBed from '../../svg/bed'
import SvgLens from '../../svg/lens'
import SvgInfoCircle from '../../svg/info-circle'
import MobileNights from './mobile-nights'

export default {
    name: 'search-form',
    components:
    {
        Spinner,
        Autocomplete,
        Datepicker,
        Occupancy,
        CustomSwitch,
        Filters,
        SvgBed,
        SvgLens,
        SvgInfoCircle,
        MobileNights,
    },
    props:{
        loading: Boolean,
        offset: Number,
        lastSearch: String,
        boxsetNights: {//serve per sovrascrivere il dates.nights preso dallo store con le notti dello specifico cofanetto
            type: Number,
            default: 0,
        },
        datePickerSelector:
        {
            type: String,
            default: 'datepicker-trigger',
        }
    },
    computed:
    {
        /*
        occupancy: {
            get() { return this.$store.state.occupancy },
            set(value) { this.mixinSendMutation('setOccupancy',value) }
        },
        dates: {
            get() { return this.$store.state.dates },
            set(value) { this.mixinSendMutation('setDates',value) }
        },
        geo: {
            get() { return this.$store.state.geo },
            set(value) { this.mixinSendMutation('setGeo',value) }
        },
        */
        unlockDestinations: {
          get() { return this.$store.state.unlockDestinations },
          set() {}
        },
        unlockUpselling: {
            get() { return this.$store.state.unlockUpselling },
            set() {}
        },
        nights: {
            get() { return this.$store.state.dates.nights },
            set() {}
        },
        selectedAmenities: {
            get() { return this.$store.state.amenities },
            set(value) { this.mixinSendMutation('setAmenities',value) }
        },
        adultsOptions:{
            get() {
            let options = [
                { value: 0, text: 'Adulti' }
            ]
            for (let a = 0; a < this.config.guiSettings.searchMaxAdults; a++) {
                let value = a+1
                let text = value==1 ? '1 adulto' : value+' adulti'
                options.push({
                value: value,
                text: text
                })
            }
            return options
            },
            set(value) { this.mixinSendMutation('setAdults', value) }
        },
        nightsOptions:{
            get() {
                let options = [
                    { value: 0, text: 'Notti' }
                ]
                if(this.mixinGetIntegrationInfo().mode == 'boxset')
                {
                    for (let a = 0; a < this.config.guiSettings.searchNights.length; a++) {
                        let value = this.config.guiSettings.searchNights[a]
                        let text = value==1 ? '1 notte' : value+' notti'
                        options.push({
                            value: value,
                            text: text
                        })
                    }
                }
                if(this.mixinGetIntegrationInfo().mode == 'booking')
                {
                    let value = this.mixinGetIntegrationInfo().integration.salabam.nights,
                        text = value==1 ? '1 notte' : value+' notti'
                    
                    options.push({
                        value: value,
                        text: text
                    })
                }
                return options
            },
            set(value) { this.mixinSendMutation('setAdults', value) }
        }
    },

    data() {
        return {
            config: Vue.prototype.$config,
            amenities: {},
            salabamCategories: {},
            debugString: '',
            checkinRange: {
                min: this.setCheckinMin(),
                max: this.setCheckinMax(),
            },
            occupancy: this.$store.state.occupancy,
            dates:this.$store.state.dates,
            geo: this.$store.state.geo,
            searchOpen: false,
            upsellingNightsOptions: [],
        }
    },

    watch: {
        // gestisco il caso in cui non trovo il valore nell'array
        // ad esempio se ho settato 14 notti, poi disabilito l'upselling e non trovo il 14 nelle notti del cofanetto, e viceversa
        // logica simile in sidebar.vue
        unlockUpselling:function() {

            if(!this.mixinGetIntegrationInfo().upselling.enabled) return
            
            let currentNights = this.nights,
                nightsArray = this.unlockUpselling ? this.upsellingNightsOptions : this.nightsOptions,
                nights = this.mixinGetIntegrationInfo().integration.salabam.nights

            let optionOk = nightsArray.filter(function(el) {
                return el.value == currentNights
            })

            if(optionOk.length > 0)
            {
                nights = currentNights
            }

            this.setNights(nights)
        }     
    },

    methods:
    {
        toggleUnlockDestinations(value)
        {
          this.mixinSendMutation('setUnlockDestinations',value)
        },        
        setCheckinMin(){
            let today = new Date(),
                tomorrow = new Date(today)
            tomorrow.setDate(tomorrow.getDate() + Vue.prototype.$config.guiSettings.minDays)
            if(today.getHours()>13)
            {
              tomorrow.setDate(tomorrow.getDate() + 1)
            }

            return tomorrow.toISOString().slice(0,10) //2019-10-29
        },
        setCheckinMax(){
            // se modalità boxset la data massima è tra un anno
            if(this.mixinGetIntegrationInfo().mode == 'boxset')
            {
                let today = new Date(),
                    nextYear = new Date(today)
                nextYear.setDate(nextYear.getDate() + 365)

                //return nextYear.getFullYear()+'-'+(nextYear.getMonth()+1)+'-'+nextYear.getDate()//2019-10-29
                return nextYear.toISOString().slice(0,10)
            }
            // se modalità booking la data massima è quella del cofanetto (integration.salabam.expireAt)
            if(this.mixinGetIntegrationInfo().mode == 'booking')
            {
                let boxsetDate = (this.mixinGetIntegrationInfo().integration.salabam.expireAt).split('-') //es 02-03-2022 => ["02","03","2022"]
                return (boxsetDate[2]+'-'+boxsetDate[1]+'-'+boxsetDate[0])
            }
        },
        setGeo(event)
        {
            this.geo = event
        },
        setDates(event)
        {
            this.dates.checkin = event
        },
        setNights(nights)
        {
            this.dates.nights = nights
            this.mixinSendMutation('setNights',nights)
            
            if(this.dates.checkin == undefined) return
            if(this.dates.checkin == "") return
        },
        setOccupancy(event)
        {
            this.occupancy = event
            //window.console.log(event)
        },
        changeFilter()
        {
            this.$emit('filter-changed')
            /*
            this.$nextTick(() => {
                this.$router.push({
                    name: 'search'
                })
            })
            */
        },
        submitSearch()
        {
            this.mixinSendMutation('setOccupancy',this.occupancy)
            this.mixinSendMutation('setDates',this.dates)
            this.mixinSendMutation('setGeo',this.geo)
            this.mixinSendMutation('setNights',this.dates.nights)
            
            /*
            if(this.offset == -1)
            {
                return
            }
            */
            
            this.$emit('submit-search')
            
            this.$nextTick(() => {
                this.setSearchFocus('hidden')
            })
        },
        setSearchFocus(status)
        {
            switch (status) {
                case 'visible':
                    this.searchOpen = true
                    break;

                case 'hidden':
                    this.searchOpen = false
                    break;
            
                case 'toggle':
                    this.searchOpen = !this.searchOpen
                    break;

                default:
                    break;
            }
        },
        disableSearchButton()
        {
            // l'offset va valutata solo se faccio non sono cambiati i criteri di ricerca, altrimenti resta -1 anche se la destinazione è cambiata
            // i campi di match devono corrispondere a search.vue let match
            let match = {
                checkin: this.dates.checkin,
                nights: this.dates.nights,
                occupancy: this.occupancy,
                lat: this.geo.latitude,
                lng: this.geo.longitude,
                matchLevel: this.geo.matchLevel,
                inSalabamId: (this.geo.inSalabamId)? this.geo.inSalabamId : 0,
                property_id: (this.geo.property_id)? this.geo.property_id : 0,
                nightlyPrice: (this.$store.state.nightlyPrice)? this.$store.state.nightlyPrice : 0,
                properties_ids: (this.geo.properties_ids)? this.geo.properties_ids : [],
            }

            let newSearch = window.btoa(JSON.stringify(Object.keys(match).sort().reduce(
                (obj, key) => {
                  obj[key] = match[key];
                  return obj;
                },
                {}
            )))

            if (newSearch == this.lastSearch) {
                if (this.offset == -1) return true
            }
            // fine gestione offset

            if (this.geo.latitude == 0) return true
            if (this.geo.longitude == 0) return true
            if (this.dates.checkin == '') return true
            if (this.occupancy.adults == 0) return true
            if (this.dates.nights == 0) return true
            return false
        },
    },

    mounted()
    {
        // se sono in /catalogo e ho cliccato su un cofanetto da X notti devo mostrare X notti e non le Y notti che, potenzialmente, sono finite nello state
        if(this.boxsetNights !== 0) this.dates.nights = this.boxsetNights

        let amenities = {
            property:{
                label: "Property", filters: []
            },
            rate:{
                label: "Rate", filters: []
            },
            refundable:{
                label: "Refundable", filters: []
            }
        }
        for (let key in this.config.amenities) {
            let level = this.config.amenities[key].level
            amenities[level].filters.push({
                text: this.config.amenities[key].label,
                value: key
            })
        }
        this.amenities = amenities
        this.salabamCategories = this.config.salabamCategories

        if(this.mixinGetIntegrationInfo().upselling.enabled)
        {
            this.upsellingNightsOptions = this.mixinGetIntegrationInfo().upselling.nightsOptions
        }

    }
}
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../../scss/_custom.scss';
    #search-form
    {
        background-color: $light-gray;
        padding-top:$grid-gutter-width/3;

        &.search-form-be {
          input, button, select {
            font-size: $font-size-base !important;
          }
        }

        .info
        {
            font-size:12px;
            margin:0;
            padding:0;
            display:flex;
            align-items:center;
            margin-left:8px;
            text-align: left;
            line-height: 120%;
            .svgInfo
            {

            }
        }

        .bookingEngineSecondRow
        {
            display:none;
            clear:both;
            width:100%;
            min-width:100%;
            text-align: left;
            padding-top:1rem;
            &.desktop
            {
                @include media-breakpoint-up(lg)
                {
                    display:block;
                }                
            }
            &.mobile
            {
                padding:0.5rem 0;
                .bookingFocusSwitch
                {
                    justify-content: center;
                }
                @include media-breakpoint-up(lg)
                {
                    display:none !important;
                }
            }
        }
        .bookingFocusSwitch
        {
            display: flex;
            align-items: center;
            .custom-switch
            {
                display: flex;
                align-items: center;                
            }
        }

        .input-icon 
        {
            svg
            {
                max-width: 90%;
                margin:0 auto;
                path
                {
                    fill:$primary;
                }
            }            
        }


        #search-form-autocomplete
        {
            display:flex;
            align-items: center;
            justify-content: center;
            justify-items: center;
        }
        #input-nights-desktop
        {
            @at-root .homepage & {
                @include media-breakpoint-up(md){
                    height:100%;
                }
            }

            @at-root .search & {
                @include media-breakpoint-up(xxl){
                    height:100%;
                }
            }

            .input-with-icon,
            .custom-select
            {
                height:100%;
                text-overflow: ellipsis; 
            }
        }
        #input-nights-desktop,
        #input-adults,
        #input-occupancy
        {
            position:relative;
        }
        #toggle-search-settings
        {
            //padding-left:$grid-gutter-width/4;
            display:flex;
            justify-content:flex-end;
            align-content:center;
            width:46px;
            svg
            {
                path
                {
                    fill:$primary;
                }
                height:auto;
            }
        }
        .btn-search
        {
            display:block;
            width: 100%;
        }
        .search-form-item
        {
            margin-bottom:14px;
        }

        #search-form-filters
        {
            button
            {
                //padding-right:0;
                margin-right:0;
                display:block;
                width:100%;
            }            
        }
    
        .searchFormHidden
        {
            display:none;
        }
        
        &.visible
        {
            .searchFormHidden
            {
                display:block;
            }    
        }

        @include media-breakpoint-up(lg)
        {
            padding-bottom: $grid-gutter-width/3;//$grid-gutter-width/3;
            //height:$search-form-desktop-height;
            //padding:2rem $grid-gutter-width;
            //box-shadow: $box-shadow;

            .searchFormHidden
            {
                display:block;
            }            

            .search-form-item
            {
                width:100%;
                margin:0 0 0 0;
                padding:0 0 0 0;
                &:not(:last-child)
                {
                    padding-right:30px;
                }
            }

            #toggle-search-settings
            {
                display:none;
            }

            form
            {
                display:flex;
                flex-wrap:wrap;
                #search-form-autocomplete { width:20%;flex:20%; }
                #search-form-datepicker { width:15%;flex:15%;position:relative;z-index:100; }
                #search-form-nights { width:12.5%;flex:12.5%; }
                #search-form-occupancy { width:20%;flex:20%; }
                #search-form-buttons {
                    width:12%;
                    flex:12%;
                }
                #search-form-filters {
                    width:8%;
                    flex:8%;
                }
                //#search-form-submit { width:100px; }
            }
        }

        


        @include media-breakpoint-down(md)
        {
            padding-left: $grid-gutter-width/2;
            padding-right: $grid-gutter-width/2;
            &.visible
            {
                background: $light-gray;
                position: relative;
                z-index: 1;
            }
        }
    }

    @include media-breakpoint-down(md)
    {
        #searchBar
        {
            margin-left:0;
            margin-right:0;
            padding-left:0;
            padding-right:0;
            background: $light-gray;
        }
        .breadcrumbs
        {
            margin:auto;
        }
    }

    #input-nights-mobile
    {
        display:block;
        @include media-breakpoint-up(md)
        {
            display:none;
        }
    }
    #input-nights-desktop
    {
        display:none;
        @include media-breakpoint-up(md)
        {
            display:block;
        }
    }


    @include media-breakpoint-down(sm)
    {
        #search-form
        {
            .input-icon
            {
                width:55px;
                text-align:center;
                svg
                {
                    margin:0 auto;
                }
            }
        }
    }

    @include media-breakpoint-up(md)
    {
        #search-form
        {
            .input-icon
            {
                svg
                {
                    height: 24px;
                    width: auto;
                    margin: 0 11px 0 10px;                    
                }
            }

            #input-occupancy .input-icon svg
            {
                width: 24px;
                height: auto
            }
        }
    }
</style>